export default {
  channel: '#thecabin',
  title: '#TheCabin',
  historyService: 'https://util.real-ity.com:9090',
  autoAwayDuration: 20000,
  ircGateway: 'https://chatgateway.the-cabin.com/webirc/kiwiirc/',

  firebaseApiKey: 'AIzaSyD6su1Ej-CgT7KdbB-YhDKjHdo_S-MQwv8',
  firebaseAuthDomain: 'thecabin-c8bf7.firebaseapp.com',
  firebaseDatabaseURL: 'https://thecabin-c8bf7.firebaseio.com',
  firebaseProjectId: 'thecabin-c8bf7',
  firebaseStorageBucket: 'thecabin-c8bf7.appspot.com',
  firebaseMessagingSenderId: '373295058991',

  bitlyAccessToken: '6ab21781e2a86392c12793e776832d638e1dd262',
}



// WEBPACK FOOTER //
// ./src/config/config.js